import chalk from 'chalk';
import { configRefs } from '@utils/constants';

var LogLevels = /* @__PURE__ */ ((LogLevels2) => {
  LogLevels2[LogLevels2["DEBUG"] = 1] = "DEBUG";
  LogLevels2[LogLevels2["LOG"] = 2] = "LOG";
  LogLevels2[LogLevels2["WARN"] = 3] = "WARN";
  LogLevels2[LogLevels2["ERROR"] = 4] = "ERROR";
  return LogLevels2;
})(LogLevels || {});
let LOG_PROCESS_PREFIX = "";
let LOG_CONTEXT_PREFIX = "";
function setLogProcessPrefix(newPrefix) {
  LOG_PROCESS_PREFIX = newPrefix;
}
function setLogContextPrefix(newPrefix) {
  LOG_CONTEXT_PREFIX = newPrefix;
}
function getMinLevel() {
  return configRefs.env.node.dangerouslyAssertSyncValue() ? 2 /* LOG */ : 1 /* DEBUG */;
}
const logger = {
  debug(...messages) {
    flush(1 /* DEBUG */, ...messages);
  },
  log(...messages) {
    flush(2 /* LOG */, ...messages);
  },
  warn(...messages) {
    flush(3 /* WARN */, ...messages);
  },
  error(...messages) {
    flush(4 /* ERROR */, ...messages);
  }
};
function flush(level, ...messages) {
  if (level < getMinLevel()) {
    return;
  }
  const prefix = formatPrefix();
  switch (level) {
    case 1 /* DEBUG */:
      console.debug(prefix, ...messages);
      break;
    case 2 /* LOG */:
      console.log(prefix, ...messages);
      break;
    case 3 /* WARN */:
      console.warn(prefix, ...messages);
      break;
    case 4 /* ERROR */:
      console.error(prefix, ...messages);
      break;
  }
}
function formatPrefix() {
  let prefix = `[${formatTimestamp(/* @__PURE__ */ new Date())}]`;
  if (LOG_PROCESS_PREFIX.length > 0) {
    prefix += ` [${LOG_PROCESS_PREFIX}]`;
  }
  if (LOG_CONTEXT_PREFIX.length > 0) {
    prefix += ` [${LOG_CONTEXT_PREFIX}]`;
  }
  return chalk.dim(prefix);
}
function formatTimestamp(tstamp) {
  const hours = `${tstamp.getHours().toString()}`.padStart(2, "0");
  const minutes = `${tstamp.getMinutes().toString()}`.padStart(2, "0");
  const seconds = `${tstamp.getSeconds().toString()}`.padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

export { LOG_CONTEXT_PREFIX, LOG_PROCESS_PREFIX, LogLevels, logger, setLogContextPrefix, setLogProcessPrefix };
//# sourceMappingURL=Logger.js.map
